import { SIDE } from '@somnhold/content';
import { withinRange } from '../math/fixed.ts';
import type { BattleState } from '../types.ts';
import { ev } from './combat.ts';

/**
 * Clues on the field (a side saga, docs/SAGAS.md): a standing hero who stays on one for a moment picks it up;
 * stepping off lets it go back to nothing. What is picked up stays with the battle, by whom, for the clue board.
 */
export const cluesTick = (s: BattleState): void => {
  const list = s.rules?.clues;
  if (!list?.length) return;
  const c = (s.clues ??= { hold: list.map(() => 0), found: [] });
  for (let i = 0; i < list.length; i++) {
    const k = list[i] as (typeof list)[number];
    if (c.found.some((f) => f.id === k.id)) continue;
    const h = s.heroes.find((x) => x.downTicks === 0 && withinRange(x.x, x.y, k.x, k.y, SIDE.clueRange));
    if (!h) {
      c.hold[i] = 0;
      continue;
    }
    c.hold[i] = (c.hold[i] ?? 0) + 1;
    if ((c.hold[i] as number) < SIDE.clueTicks) continue;
    c.found.push({ id: k.id, pid: h.pid, tick: s.tick });
    ev(s, { t: 'clue', id: k.id, pid: h.pid, x: k.x, y: k.y });
  }
};
